import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {AuthService, UsersService} from "..";
import {Observable} from "rxjs";
import {HelperService} from "../helperService";


/**
 * Class ClientSelectionResolver
 */
@Injectable()
export class ClientSelectionResolver
{


	/**
	 * Function > constructor
	 * @param {NavigationService} OBJ_navigation_service
	 * @param {AuthService} OBJ_auth_service
	 * @param {UsersService} OBJ_user_service
	 * @param {HelperService} OBJ_helper_service
	 */
    constructor
	(
        private OBJ_navigation_service: NavigationService,
        private OBJ_auth_service: AuthService,
		private OBJ_user_service: UsersService,
		private OBJ_helper_service: HelperService
	) {} // end function constructor


    /**
     * Function > resolve
     * @param {ActivatedRouteSnapshot} OBJ_route
     * @param {RouterStateSnapshot} OBJ_state
     * @return {Observable}
     */
    resolve (OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): Observable<any>
	{

		this.OBJ_helper_service.logWithClassAndFunction("ClientSelectionResolver", "resolve", OBJ_route, OBJ_state);

		// get config
		let OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');

		// fetch current user and set them to loacl storage
		return this.OBJ_auth_service.auth(OBJ_config.auth.url_auth);

	} // end function resolve


} // end class ClientSelectionResolver
